import { useState } from 'react'
import { UserProfileManager } from '../utils/userProfile'
import './ProfileSetup.css'

interface ProfileSetupProps {
  onComplete: () => void
}

const AVATAR_OPTIONS = [
  '😀', '😎', '🤓', '🥳', '🤩', '😈', '👽', '🤖', '🎮', '🎯',
  '🎲', '🎪', '🎨', '🎭', '🎸', '🚀', '⚡', '🔥', '✨', '🌟',
  '🦄', '🐉', '🦊', '🐺', '🦁', '🐯', '🐸', '🐙', '🦋', '🌈',
]

export function ProfileSetup({ onComplete }: ProfileSetupProps) {
  const [name, setName] = useState('')
  const [selectedAvatar, setSelectedAvatar] = useState(AVATAR_OPTIONS[0])
  const [error, setError] = useState('')

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()

    const trimmedName = name.trim()
    if (trimmedName.length < 2) {
      setError('Name must be at least 2 characters')
      return
    }
    if (trimmedName.length > 20) {
      setError('Name must be less than 20 characters')
      return
    }

    // Save profile
    UserProfileManager.save(trimmedName, selectedAvatar)
    onComplete()
  }

  return (
    <div className="profile-setup-overlay">
      <div className="profile-setup-modal">
        <div className="profile-setup-header">
          <h2>Welcome to zGames! 🎮</h2>
          <p>Create your player profile to get started</p>
        </div>

        <form onSubmit={handleSubmit} className="profile-setup-form">
          {/* Avatar Selection */}
          <div className="form-section">
            <label className="form-label">Choose Your Avatar</label>
            <div className="avatar-grid">
              {AVATAR_OPTIONS.map((emoji) => (
                <button
                  key={emoji}
                  type="button"
                  className={`avatar-option ${selectedAvatar === emoji ? 'selected' : ''}`}
                  onClick={() => setSelectedAvatar(emoji)}
                >
                  {emoji}
                </button>
              ))}
            </div>
          </div>

          {/* Name Input */}
          <div className="form-section">
            <label className="form-label">Your Name</label>
            <input
              type="text"
              className="profile-name-input input"
              placeholder="Enter your name..."
              value={name}
              onChange={(e) => {
                setName(e.target.value)
                setError('')
              }}
              maxLength={20}
              autoFocus
            />
            {error && <div className="error-message">{error}</div>}
          </div>

          {/* Submit Button */}
          <button type="submit" className="btn btn-primary btn-lg" disabled={name.trim().length < 2}>
            Start Playing 🚀
          </button>
        </form>

        <div className="profile-setup-footer">
          <p className="help-text">
            Your profile is saved locally on this device.<br />
            You can change it anytime from the homepage.
          </p>
        </div>
      </div>
    </div>
  )
}
